import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $insertNodes } from "lexical";
import { $generateNodesFromDOM } from "@lexical/html";

export function useLessonSkip({
  setActiveWorkboard,
  setActiveTab,
  setIsAssignment,
  setIsRubric,
  setAssignmentCounts,
  setAssignmentCountsTwo,
  setSelectedAssignment,
  setPopupVisible,
  checkAssignmentopen,
  setFormState,
  setSkipLesson,
  workboards,
  assignmentsCount,
  setskipLessonSession
}) {
  const [editor] = useLexicalComposerContext();

  const handleSkipLesson = (e, handleForm1Submit) => {
    e?.preventDefault?.();

    // Save skip flag
    sessionStorage.setItem("skipLesson", "true");

    // Set main state
    setActiveWorkboard(workboards.ASSIGNMENT);
    setActiveTab("lesson");
    setIsAssignment(true);
    setIsRubric(false);

    // Create default assignment
    const newAssignment = "Assignment 1";
    setAssignmentCounts([newAssignment]);
    setAssignmentCountsTwo(0);
    setSelectedAssignment(newAssignment);

    // Open assignment popup
    setPopupVisible(true);

    // Set chat query only if assignment not open
    if (!checkAssignmentopen) {
      setFormState((prev) => ({
        ...prev,
        chat_query: `Create Assignment ${assignmentsCount.length + 1}`,
      }));
    }

    // Clear editor content
    editor.update(() => {
      try {
        const root = $getRoot();
        root.clear();
        const nodes = $generateNodesFromDOM(editor, "");
        $insertNodes(nodes);
      } catch (error) {
        console.error("Error resetting editor:", error);
      }
    });

    // Close popup and trigger submit
    setSkipLesson(false);
    setskipLessonSession(false)
    if (typeof handleForm1Submit === "function") handleForm1Submit(e);
  };

  const handleCancelSkip = () => {
    setSkipLesson(false);
    sessionStorage.removeItem("skipLesson");
  };

  return {
    handleSkipLesson,
    handleCancelSkip,
  };
}
